import axios from '../../../build/http-requests/axios-common'

export default {
  actions: {
    searchRemittanceIntegration: (_, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/remittanceIntegration/search', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getRemittanceTypes: () => {
      return new Promise((resolve, reject) => {
        axios.get('/remittanceIntegration/getRemittanceTypes').then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getRemittanceDetail: (_, idRemittance) => {
      return new Promise((resolve, reject) => {
        axios.get('/remittanceIntegration/getRemittanceDetail', {
          params: {
            idRemittance
          }
        }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    createRemittance: (_, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/remittanceIntegration/create', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    remittanceDetail: (_, idRemittance) => {
      return new Promise((resolve, reject) => {
        axios.get('/remittanceIntegration/remittanceDetail', {
          params: {
            idRemittance
          }
        }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    validateRemittancePeriod: (_, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/remittanceIntegration/validateRemittancePeriod', data).then(response => {
          resolve(response.data.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    searchRemittanceSummary: (_, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/remittanceIntegration/searchRemittanceSummary', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    remittanceDownload: (_, idMovFinan) => {
      return new Promise((resolve, reject) => {
        axios.post('/remittanceIntegration/download', {
          params: {
            idMovFinan
          }
        }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    removeRemittance: (_, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/remittanceIntegration/removeRemittance', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/remittanceIntegration.js